import React, { FC, useState } from 'react';
import { TeamID } from '../../scripts/models/common';
import LoadingPage from '../common/LoadingPage';
import TeamSelector from '../common/teamSelector/TeamSelector';
import { DataContext } from '../context/dataLoader/DataLoader';

import TeamModificationsDisplay from './teamModsDisplay/TeamModificationsDisplay';

const ModificationViewer: FC = () => {

    const [team, selectedTeam] = useState<TeamID>()
    const data = React.useContext(DataContext)

    if (!data.teamCollections) {
        return <LoadingPage />
    }

    return <div className='Page ModificationViewer'>
        <TeamSelector currentTeam={team} setter={selectedTeam} teams={data.teamCollections.allTeams} />
        <TeamModificationsDisplay teamID={team} />
    </div>
}

export default ModificationViewer;